import { commonRoutes } from '../../routes/commonRoutes';
export const supermarketRoutes = commonRoutes;
